module.exports = __webpack_public_path__ + "img/red_063.bf3bcc41.png";